import React from 'react';
import { useState, useEffect } from "react";

import { Link, Alert, Box, Container, List, ListItem, Typography} from '@mui/material';
import { formatDate } from "/@/app/utils.jsx";
import { Spinner } from "/@/app/components/Spinner.jsx";
import { useApi} from '/@/app/Api';

export const SubscriptionsHistoryView = () => {
    const api=useApi();
    const [payments, setPayments] = useState(null);

    useEffect(() => {
        if (payments !== null) return;
        api.request('billing/payments/').then(data => {
            setPayments(data);
        })
    }, []);

    return (
        <Container maxWidth="md" sx={{ mb: 10 }}>
            <Typography variant="h2" sx={{ textAlign: 'center' }} gutterBottom>
                История подписок
            </Typography>
            {!payments
                ? <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Spinner size={80} />
                </Box>
                : <>
                    {payments.length === 0
                        ?
                        <Alert severity='info'>Пока нет подписок или оплат.</Alert>
                        : <List>
                            {payments.map((payment, idx) =>
                                <ListItem key={ idx } sx={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(5, 1fr)',
                                    gap: 2,
                                    backgroundColor: payment.active_till ? 'rgba(211,246,211,0.5)' : 'inherit',
                                }}>
                                    <Box>
                                        {payment.plan}
                                        <br />
                                        {(payment.amount_cents / 100).toFixed(2)} {" "}
                                        {payment.currency}
                                        {payment.donation_amount_cents > 0 &&
                                            <>
                                                <br />
                                                <span style={{ color: 'green', fontSize: '14px' }}>+ пожертвование</span>
                                                <br />
                                                <span style={{ color: 'green' }}>
                                                    {(payment.donation_amount_cents / 100).toFixed(2)} {" "}
                                                    {payment.currency}
                                                </span>
                                            </>
                                        }
                                    </Box>
                                    <Box>
                                        оплата запрошена: {payment.payment_requested_at ? formatDate(payment.payment_requested_at) : ''}
                                        {payment.payment_status === 'new' &&
                                            <>
                                                <br />
                                                <Link target="_blank" href={payment.payment_frontend_redirect}>Ссылка на оплату</Link>
                                            </>
                                        }
                                    </Box>
                                    <Box>оплата завершена: {payment.payment_received_at ? formatDate(payment.payment_received_at) : ''}</Box>
                                    <Box>статус оплаты: {payment.payment_status}</Box>
                                    <Box>подписка активирована до: {payment.active_till ? formatDate(payment.active_till) : "" }</Box>
                                </ListItem>
                            )}
                        </List>
                    }
                </>
            }
        </Container>
    )
}
